module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "elmapa",
    attrs: {
      "id": 'map_' + _vm.pagina.id,
      "lat": _vm.pagina.acf.mapa.lat,
      "lng": _vm.pagina.acf.mapa.lng
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-centermid mapa__descripcion"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.pagina.content.rendered)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "como",
    attrs: {
      "href": 'https://www.google.com.py/maps/@' + _vm.pagina.acf.mapa.lat + ',' + _vm.pagina.acf.mapa.lng + 'z',
      "target": "_blank"
    }
  }, [_vm._v("Como llegar")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b32adf3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_mapa.vue
// module id = 147
// module chunks = 0